<script>
    import RoleAddHeader from '@/components/page-user-edit/role-add/RoleAddHeader.vue';
    import RoleAddData from '@/components/page-user-edit/role-add/RoleAddData.vue';

    export default {
        components: {
            RoleAddHeader: RoleAddHeader,
            RoleAddData: RoleAddData,
        },
        computed: {
            isShowRoleAdd() {return this.$store.getters.IS_SHOW_ROLE_ADD},
        }
    }
</script>


<template>
    <div
        v-if="isShowRoleAdd"
        class="left_additional_container"
    >
        <RoleAddHeader />
        <hr class="hr_light_98">
        <RoleAddData />
    </div>
</template>


<style scoped>

</style>